import {DashboardFilter} from '../../globals/Constants';

function getUrlQueryParam(search: string, variable: string): string {
   const paramVal = new URLSearchParams(search).get(variable);
   // this just preserves legacy behavior of this func, URLSearchParams would natively
   // return 'null' for notfound and ''(empty - string) for param exists with no value
   return paramVal === null ? '' :
      paramVal === '' ? variable :
      paramVal;
}

function getTabHref(urlOriginAndPath: string, urlParams: Record<string, string>, type: string): string {
   const urlParamsObject = new URLSearchParams(urlParams);

   if (type === DashboardFilter.owned) {
      urlParamsObject.set('filter', DashboardFilter.owned);
   } else if (type === DashboardFilter.others) {
      urlParamsObject.set('filter', DashboardFilter.others);
   } else {
      urlParamsObject.delete('filter');
   }
   return `${urlOriginAndPath}${urlParamsObject.toString() ? `?${urlParamsObject.toString()}` : '' }`;
}

export default {
   getUrlQueryParam,
   getTabHref
};
